<template>
  <div class="flex-1 overflow-auto focus:outline-none" tabindex="0">
    Test
  </div>
</template>

<script>
export default {
  name: 'wms',
  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
